import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/quantware.webp';
import screenshot_target from '../../../images/letterfunnel/alessandrobruno.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Alessandro Bruno"
      firstname="Alessandro"
      companyname="QuantWare"
      competition="IQM en SEEQC"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/alessandrobruno.js